/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_P_Kelas_DescInputs */

const en_cp_p_kelas_desc = /** @type {(inputs: Cp_P_Kelas_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10–39 teams, one invoice for the lecturer/department. Includes a 90-minute online kickoff, grading rubric, lecturer dashboard, email support.`)
};

const id_cp_p_kelas_desc = /** @type {(inputs: Cp_P_Kelas_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10–39 tim, 1 invoice untuk dosen/prodi. Termasuk kickoff daring 90 menit, rubrik penilaian, dashboard dosen, dukungan email.`)
};

/**
* | output |
* | --- |
* | "10–39 teams, one invoice for the lecturer/department. Includes a 90-minute online kickoff, grading rubric, lecturer dashboard, email support." |
*
* @param {Cp_P_Kelas_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_p_kelas_desc = /** @type {((inputs?: Cp_P_Kelas_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_P_Kelas_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_p_kelas_desc(inputs)
	return en_cp_p_kelas_desc(inputs)
});